import { combineReducers } from 'redux'
import appReducer from './reducers/appReducer'
import authReducer from './reducers/authReducer'
import usersReducer from './reducers/usersReducer'
import stepReducer from './reducers/stepReducer'
import workflowReducer from './reducers/workflowReducer'
import organizationReducer from './reducers/organizationReducer'
import durationReducer from './reducers/wfDurationReducer'
import functionReducer from './reducers/functionReducer'
import groupReducer from './reducers/groupReducer'
import configReducer from './reducers/configReducer'
import configTwoReducer from './reducers/configtwoReducer'
import grouprouteReducer from './reducers/GrouprouteReducer'
import resetpasswordReducer from './reducers/resetpasswordReducer'
import dashboardReducer from './reducers/dashboardReducer'
import adminAnalyticsReducer from './reducers/adminAnalyticsReducer'
import userAnalyticsReducer from './reducers/userAnalyticsReducer'
import dashboardLayoutReducer from './reducers/dashboardLayoutReducer'
import formReducer from './reducers/formReducer'
import fieldReducer from './reducers/fieldReducer'
import fieldTypeReducer from './reducers/fieldTypeReducer'
import queryReducer from './reducers/queryReducer'
import productReducer from './reducers/productReducer'
import casesReducer from './reducers/casesReducer'
import routeListReducer from './reducers/routeConfigReducer'
import sectionReducer from './reducers/sectionReducer'
import templateReducer from './reducers/templateReducer'
import radioReducer from './reducers/radioReducer'
import checkboxReducer from './reducers/checkboxReducer'
import selectboxReducer from './reducers/selectboxReducer'
import historyReducer from './reducers/historyReducer'
import loaderReducer from './reducers/loaderReducer'
import flagReducer from './reducers/flagReducer'
import whoReducer from './reducers/whoReducer'
import meddraReducer from './reducers/meddraReducer'
import countryReducer from './reducers/forms/countryReducer'
import formSelectbox from './reducers/staticFormReducer/formSelectReducer'
import basicCaseReducer from './reducers/staticFormReducer/basicCaseReducer'
import primaryCaseReducer from './reducers/staticFormReducer/primaryCaseReducer'
import eventCaseReducer from './reducers/staticFormReducer/eventCaseReducer'
import patientReducer from './reducers/staticFormReducer/patientReducer'
import productInfoReducer from './reducers/staticFormReducer/productInfoReducer'
import prodeuctReactionReducer from './reducers/staticFormReducer/productReactionReducer'
import basicProductReducer from './reducers/staticFormReducer/basicProductReducer'
import productAdminReducer from './reducers/productAdminReducer'
import studyManagReducer from './reducers/studyManagReducer'
import institutionReducer from './reducers/institutionReducer'
import senderDetailsReducer from './reducers/senderDetailsReducer'
import receiverDetailsReducer from './reducers/receiverReducer'
import generalReducer from './reducers/generalReducer'
import xmlReducer from './reducers/xmlReducer'
import xmlSubmissionReducer from './reducers/xmlSubmissionReducer'
import pdfReducer from './reducers/pdfReducer'
import armsReducer from './reducers/armsReducer'
import stateReducer from './reducers/stateReducer'
import duplicateReducer from './reducers/duplicateReducer'
import caseTemplateReducer from './reducers/caseTemplateReducer'
import { USER_LOGOUT } from './types'
import storage from 'redux-persist/lib/storage'
import caseHistoryReducer from './reducers/caseHistoryReducer'
import s3Reducer from './reducers/s3Reducer'
// import reportMedWatch from './reducers/reportMedWatchReducer'
import reportMedWatch from './reducers/reportMedWatchReducer'
import caseVersionReducer from './reducers/caseVersionReducer'
import SubmissionDetailsReducer from './reducers/caseSubmissionReducer'
import customiseTableReducer from './reducers/customiseTableReducer'
import regulatoryReportReducer from './reducers/regulatoryReport/regulatoryReportReducer'
import duplicateCheckReducer from './reducers/duplicateSettingReducer'
import notificationReducer from './reducers/notificationReducer'
import caseTriageReducer from './reducers/caseTriageReducer'
import pupMedReducer from './reducers/pupMedReducer'
import emailReducer from './reducers/emailReducer'
import sourceDataReducer from './reducers/researchReducer'
import as2ResponseReducer from './reducers/as2ResponseReducer'
import chatConversationReducer from './reducers/chatReducer'
import allocationReducer from './reducers/allocationReducer'
import checkListReducer from './reducers/checkListReducer'
import adminFormFieldReducer from './reducers/adminfieldmanagementReducer'
import excelUploadReducer from './reducers/excelUploadReducer'

////Mobile AAdmin
import userLevelReducer from './reducers/adrModuleReducer/userLevelReducer'
import userTypeReducer from './reducers/adrModuleReducer/userTypeReducer'
import userDesignationReducer from './reducers/adrModuleReducer/userDesignationReducer'
import userADRReducer from './reducers/adrModuleReducer/userReducer'
import departmentReducer from './reducers/adrModuleReducer/departmentReducer'
import sourceTypeReducer from './reducers/adrModuleReducer/sourceTypeReducer'
import facilityReducer from './reducers/adrModuleReducer/facilityReducer'
import ageGroupReducer from './reducers/adrModuleReducer/ageGroupReucer'
import resolutionReducer from './reducers/adrModuleReducer/resolutionReducer'
import reporterRoleReducer from './reducers/adrModuleReducer/reporterRoleReducer'
import severityReducer from './reducers/adrModuleReducer/severityReducer'
import naranjoReducer from './reducers/adrModuleReducer/naranjoReducer'
import fieldManageReducer from './reducers/adrModuleReducer/fieldManagReducer'
import regulatoryGateWay from './reducers/gateWayReducer/gateWayReducer'

import literactureQuery from './reducers/literactureQueryReducer'

// esignature reducer
import eSignatureReducer from './reducers/eSignatureReducer'

//// TGA
import multiSourceReducer from './reducers/multiSource/multiSource'
import adverseEventReducer from './reducers/tgaReducer/adverseEventReducer'
import multiSourceExtraction from './reducers/multiSourceExtractionReducer'
import llmSettingsReducer from './reducers/llmSettingsReducer'
import signalAnalysisReducer from './reducers/signalAnalysisReducer'

const allReducer = combineReducers({
  appReducer,
  authReducer,
  usersReducer,
  stepReducer,
  workflowReducer,
  organizationReducer,
  functionReducer,
  groupReducer,
  grouprouteReducer,
  configReducer,
  configTwoReducer,
  resetpasswordReducer,
  dashboardReducer,
  adminAnalyticsReducer,
  userAnalyticsReducer,
  dashboardLayoutReducer,
  formReducer,
  fieldReducer,
  fieldTypeReducer,
  productAdminReducer,
  queryReducer,
  historyReducer,
  productReducer,
  casesReducer,
  radioReducer,
  checkboxReducer,
  selectboxReducer,
  routeListReducer,
  sectionReducer,
  templateReducer,
  loaderReducer,
  meddraReducer,
  flagReducer,
  countryReducer,
  whoReducer,
  formSelectbox,
  basicCaseReducer,
  primaryCaseReducer,
  eventCaseReducer,
  patientReducer,
  productInfoReducer,
  prodeuctReactionReducer,
  basicProductReducer,
  studyManagReducer,
  institutionReducer,
  senderDetailsReducer,
  generalReducer,
  receiverDetailsReducer,
  xmlReducer,
  duplicateReducer,
  xmlSubmissionReducer,
  caseTemplateReducer,
  pdfReducer,
  caseHistoryReducer,
  armsReducer,
  stateReducer,
  s3Reducer,
  reportMedWatch,
  regulatoryReportReducer,
  caseVersionReducer,
  SubmissionDetailsReducer,
  customiseTableReducer,
  durationReducer,
  duplicateCheckReducer,
  notificationReducer,
  caseTriageReducer,
  pupMedReducer,
  emailReducer,
  sourceDataReducer,
  as2ResponseReducer,
  chatConversationReducer,
  allocationReducer,
  adminFormFieldReducer,
  checkListReducer,
  excelUploadReducer,
  userLevelReducer,
  userTypeReducer,
  userDesignationReducer,
  userADRReducer,
  departmentReducer,
  sourceTypeReducer,
  facilityReducer,
  ageGroupReducer,
  resolutionReducer,
  severityReducer,
  reporterRoleReducer,
  naranjoReducer,
  fieldManageReducer,
  literactureQuery,
  regulatoryGateWay,
  adverseEventReducer,
  eSignatureReducer,
  multiSourceReducer,
  multiSourceExtraction,
  llmSettingsReducer,
  signalAnalysisReducer,
})

const rootReducer = (state, action) => {
  if (action.type === USER_LOGOUT) {
    storage.removeItem('persist:root')
    state = undefined
  }
  return allReducer(state, action)
}

export default rootReducer
